import CallHistory from './CallHistory';

const CallHistoryConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/call-history',
			component: CallHistory
		}
	]
};

export default CallHistoryConfig;
